import actions from "./actions";

const initState = {

    vendorList: [],
    getVendorLoading: false,
    getVendorError: null,

    aCodeList: [],
    getACodeLoading: false,
    getACodeError: null,

    planList: [],
    getPlanLoading: false,
    getPlanError: null,

    billingCodeList: [],
    billingCodeLoading: false,
    billingCodeError: null,
};

export default function reducer(state = initState, action) {
    switch (action.type) {
        case actions.GET_VENDOR:
            return {
                ...state,
                vendorList: [],
                getVendorLoading: true,
                getVendorError: null,
            };
        case actions.GET_VENDOR_SUCCESS:
            return {
                ...state,
                vendorList: action.data,
                getVendorLoading: false,
                getVendorError: null,
            };
        case actions.GET_VENDOR_FAILED:
            return {
                ...state,
                getVendorLoading: false,
                getVendorError: action.error,
            }
        case actions.GET_ACODE:
            return {
                ...state,
                aCodeList: [],
                getACodeLoading: true,
                getACodeError: null,
            };
        case actions.GET_ACODE_SUCCESS:
            return {
                ...state,
                aCodeList: action.data,
                getACodeLoading: false,
                getACodeError: null,
            };
        case actions.GET_ACODE_FAILED:
            return {
                ...state,
                getACodeLoading: false,
                getACodeError: action.error,
            };
        case actions.GET_PLAN:
            return {
                ...state,
                planList: [],
                getPlanLoading: true,
                getPlanError: null,
            };
        case actions.GET_PLAN_SUCCESS:
            return {
                ...state,
                getPlanLoading: false,
                planList: action.result,
                getPlanError: null,
            };
        case actions.GET_PLAN_FAILED:
            return {
                ...state,
                getPlanLoading: false,
                getPlanError: action.error,
            };

        case actions.GET_BILLING_CODE:
            return {
                ...state,
                billingCodeList: [],
                billingCodeLoading: false,
                billingCodeError: null,
            };
        case actions.GET_BILLING_CODE_SUCCESS:
            return {
                ...state,
                billingCodeLoading: false,
                billingCodeList: action.result,
                billingCodeError: null,
            };
        case actions.GET_BILLING_CODE_FAILED:
            return {
                ...state,
                billingCodeLoading: false,
                billingCodeError: action.error,
            };
        default:
            return state;
    }
}
